import { FunctionComponent, Suspense } from "react";
import classNames from "classnames";
import { useConfigurio } from "@rromikas/configurio";
import TakePhotoButton from "../editor/take-photo-button";
import { MODEL_DATA_TEST_ID, OPTION_BUTTON_TEST_ID } from "constants/test";

interface ConfiguratorPreviewProps extends ReturnType<typeof useConfigurio> {}

declare var window: any;

const ConfiguratorPreview: FunctionComponent<ConfiguratorPreviewProps> = ({
  configurator,
  modelViewer,
  options,
  canvasRef,
  userSelections,
  model,
}) => {
  window[MODEL_DATA_TEST_ID] = model;
  const totalPrice = (configurator?.base_price ?? 0) + userSelections.reduce((a, b) => a + b.option.price, 0);

  return (
    <div className="w-full h-full flex bg-white overflow-auto">
      <div className="flex-grow w-0 sticky top-0">
        <Suspense>
          {modelViewer} <TakePhotoButton canvasRef={canvasRef} />
        </Suspense>
      </div>
      <div className="flex-shrink-0 w-[430px] flex border-l">
        <div className="my-auto p-9">
          <div className="text-[24px] font-bold mb-4">{configurator?.product_title}</div>
          <div className="mb-6">
            <div className="text-lg">Price</div>
            <div className="font-bold text-[32px]">${totalPrice}</div>
          </div>
          <div className="space-y-7">
            {options.map((c, i) => (
              <div key={`customizer-${i}`} className="overflow-hidden">
                <div className="mb-3 text-lg">{c.label}</div>
                <div className="flex -m-2 flex-wrap">
                  {c.options.map((option, j) => (
                    <div key={`cus-${i}-option-${j}`} className="p-2">
                      <div
                        data-testid={OPTION_BUTTON_TEST_ID(option.id)}
                        onClick={option.select}
                        className={classNames("cursor-pointer bg-gray-100 p-2 rounded-[10px] border-2 select-none font-normal", {
                          "border-main-to": option.isSelected,
                          "border-transparent": !option.isSelected,
                        })}
                      >
                        <div
                          style={
                            option.value.type === "color"
                              ? { backgroundColor: option.value.value }
                              : { backgroundImage: `url(${option.value.modelImageUrl})` }
                          }
                          className="w-[50px] h-[50px] rounded-[9px] mx-auto mb-3 bg-center bg-cover"
                        ></div>
                        <div className="text-center opacity-50 text-xs">
                          <div>{option.label}</div>
                          <div>{!option.price ? "Free" : `$${option.price}`}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguratorPreview;
